module.exports = __webpack_public_path__ + "public/images/stand-arrow.a04fc2b75b44ba27c59feace84142f1c.svg";